<template>
  <div>
    <Head title="Fragen wiederholen"/>
    <h1 class="h1">
      Fragen wiederholen
    </h1>

    <div class="mb-6 text-sm md:text-base">
      <p>Hier kannst du die Fragen üben, die du mindestens einmal in den Themen oder Prüfungen falsch
        beantwortet hast. Beantwortest du sie hier richtig, verschwindet die Frage aus deinem
        Wiederholungspool, es sei denn, du markierst sie zur erneuten Vorlage mit "später noch mal üben".
        So kannst du deinen Lernprozess optimal gestalten und schwierige Fragen so oft wiederholen, wie es
        für dich richtig ist.</p>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <div class="column">
        <h2 class="font-semibold lg:text-lg mb-4">{{ __('mistakes.statistics') }}</h2>
        <div class="card">

          <div class="overflow-x-auto relative">
            <table class="w-full text-sm text-left text-gray-500">
              <tbody>
              <tr class="bg-white border-b">
                <th scope="row" class="p-2 lg:p-4 text-xs text-gray-700 uppercase bg-gray-50">
                  {{ __('mistakes.made') }}
                </th>
                <td class="p-2 lg:py-4 lg:px-6 text-right">
                  {{ mistakes.length }}
                </td>
              </tr>
<!--              <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">-->
<!--                <th scope="row" class="p-2 lg:p-4 text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">-->
<!--                  {{ __('mistakes.fixed') }}-->
<!--                </th>-->
<!--                <td class="p-2 lg:py-4 lg:px-6 text-right">-->
<!--                  TODO-->
<!--                </td>-->
<!--              </tr>-->
              <tr class="bg-white border-b">
                <th scope="row" class="p-2 lg:p-4 text-xs text-gray-700 uppercase bg-gray-50">
                  {{ __('mistakes.multiple_made') }}
                </th>
                <td class="p-2 lg:py-4 lg:px-6 text-right">
                  {{ multipleMistakes.length }}
                </td>
              </tr>
              <tr class="bg-white border-b">
                <th scope="row" class="p-2 lg:p-4 text-xs text-gray-700 uppercase bg-gray-50">
                  {{ __('mistakes.current_tendency') }}
                </th>
                <td class="p-2 lg:py-4 lg:px-6 text-right">
                  <tendency :value="overalltendency" />
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div v-if="mistakes.length > 0" class="mt-4 flex justify-end">
            <a href="/meine-fehler/lernen" class="btn w-auto inline-flex btn-primary">{{ __('mistakes.practice_recent') }}</a>
          </div>
        </div>
      </div>
    </div>

    <mistake-modal
        v-if="currentMistake"
        :show-modal="showModal"
        :mistake="currentMistake"
        @mistake-learned="markMistakeAsLearned"
        @close="toggleModal" />
  </div>
</template>

<script>
import Tendency from '../../Shared/Mistakes/Tendency'
import Layout from '../../Shared/Layout'
import MistakeModal from '../../Shared/Mistakes/MistakeModal'
import {Head} from '@inertiajs/inertia-vue3'

import {markMistakeAsLearned} from '../../api/MistakeApi'
import Alert from '../../Shared/Components/Alert.vue'

export default {
  name: 'Index',

  components: {
    Alert,
    Head,
    Tendency,
    MistakeModal,
  },

  layout: Layout,

  props: {
    mistakes: {
      type: Array,
      required: true,
    },
    overalltendency: {
      type: Number,
      required: false,
    },
  },

  data() {
    return {
      showModal: false,
      currentMistake: null,
      playSuccessAnimation: false,
    }
  },

  computed: {
    multipleMistakes() {
      return this.mistakes.filter( mistake => {
        return mistake.times_wrong > 1
      })
    },

    overallTendency() {
      let tendency = 0
      this.mistakes.map( mistake => {
        tendency += mistake.tendency
      })

      return Math.floor( tendency / this.mistakes.length )
    },
  },

  methods: {
    openModal: function( mistake ) {
      this.currentMistake = mistake
      this.showModal = true
    },

    toggleModal: function() {
      this.showModal = !this.showModal
    },

    markMistakeAsLearned: async function( mistake ) {
      this.currentMistake = mistake
      let result = await markMistakeAsLearned( this.currentMistake.id )
      if( result ) {
        let index = this.mistakes.findIndex( (mistake) => mistake.id === this.currentMistake.id )
        console.log("INDEX", index )
        // eslint-disable-next-line vue/no-mutating-props
        this.mistakes.splice( index, 1 )
        this.playSuccessAnimation = true
        setTimeout(() => {
          this.playSuccessAnimation = false
        }, 1000 )
      }
    },
  },
}
</script>

<style scoped>
@media( min-width: 768px ) {
  .draggable__wrapper {
    max-height: 60vh;
    overflow-y: scroll;
    padding-right: 30px;
  }
}
</style>
